import React from 'react'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ value, onChange, name, id, text }) => {
  return (
    <Form.Group>
      <Form.Label text={text} md={4} />
      <Col md={7}>
        <Form.InputDate value={value} name={name} id={id} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default FechaFormGroup
